<section class="events-header-wrap">
    <div class="flex" *ngIf="!showNoEventsMessage; else noEventsForFilter">
      <div class="title-wrap">
        <div class="sport-text h2">
          <span *ngIf="!(srcSelection && srcSelection.sport && srcSelection.sport.id < 0 && eventsNumber > 0) || (pageType == pageTypeEnum.Soon || pageType == pageTypeEnum.MostPopular)">{{subtitle}}</span>
          <span *ngIf="srcSelection && srcSelection.sport && srcSelection.sport.id < 0 && eventsNumber > 0 && pageType != pageTypeEnum.Soon && pageType != pageTypeEnum.MostPopular">{{title}}
            <span class="events-number">({{eventsNumber}})</span>
          </span>
        </div>
        <div class="text-wrap">
          <!-- <div class="region-name">{{subtitle}}</div> -->
          <div class="competition-title" *ngIf="srcSelection && srcSelection.sport && srcSelection.sport.id > 0">{{title}}
            <span class="events-number" *ngIf="eventsNumber > 0 && pageType === pageTypeEnum.Prematch" >({{eventsNumber}})</span>
          </div>
          <div *ngIf="isMobileView && (pageType == pageTypeEnum.Soon || pageType == pageTypeEnum.MostPopular)" class="back btn primary small rounded" (click)="backToTree()">
            <ng-container i18n="Back button@@BackButton">Nazad</ng-container>
          </div>
        </div>
      </div>

      <app-events-bet-type-groups *ngIf="eventsGroupVM && eventsGroupVM.specialOfferType != specialOfferTypeEnum.Outrights" [betTypeGroups]="eventsGroupVM.betTypeGroups"
        [specialOfferType]="eventsGroupVM.specialOfferType" [selectionChanged]="selectionChanged"
        [sportId]="eventsGroupVM.sportId" [regionId]="eventsGroupVM.regionId" [competitionId]="eventsGroupVM.competitionId">
      </app-events-bet-type-groups>

      <!-- <div class="sorting-wrap">
                <div class="selected-item" (click)="toggleLiveSorting()">{{leagueTimeFilter}}</div>
                <div class="options-wrap box" *ngIf="showSortingForLive">
                    <span class="item title">sortiraj po</span>
                    <span class="item" [class.selected]="leagueTimeFilter == leagueTimeFilterTypeEnum.League" (click)="filterByLeagueTime(leagueTimeFilterTypeEnum.League)">{{leagueTimeFilterTypeEnum.League}}</span>
                    <span class="item" [class.selected]="leagueTimeFilter == leagueTimeFilterTypeEnum.Time" (click)="filterByLeagueTime(leagueTimeFilterTypeEnum.Time)">{{leagueTimeFilterTypeEnum.Time}}</span>
                </div>
            </div> -->
    </div>
    <ng-template #noEventsForFilter>
      <div class="title-wrap">
        <div class="text-wrap">
          <div class="h2 empty-h2" i18n="There are no events for the selected filter@@EmptyFilterResultEvents">Nema mečeva za odabrani filter</div>
          <div *ngIf="isMobileView && (pageType == pageTypeEnum.Soon || pageType == pageTypeEnum.MostPopular)" class="back btn primary small rounded" (click)="backToTree()">
            <ng-container i18n="Back button@@BackButton">Nazad</ng-container>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="league-title-wrap" *ngIf="(pageType === pageTypeEnum.MostPopular || pageType === pageTypeEnum.Soon || pageType == pageTypeEnum.Prematch) && tabs?.length > 0 && !showNoEventsMessage;">
      <ng-container *ngFor="let tab of tabs">

        <div *ngIf="tab.eventsCount > 0 || ((pageType === pageTypeEnum.MostPopular || pageType === pageTypeEnum.Soon) && !viewConfigurations.useSoonViewWhenTimeFilterIsChanged)" [class.selected]="tab.isSelected"  (click)="selectTab(tab)">
          <ng-container *ngIf="tab.competitions && tabsType == eventHeaderTabTypeEnum.RegionAndCompetitions; else tabName">Sve</ng-container>
          <ng-template #tabName>{{tab.name}}</ng-template>
          <span class="events-number" *ngIf="pageType == pageTypeEnum.Prematch" > ({{tab.eventsCount}})</span>
        </div>
      </ng-container>
    </div>

</section>
